import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
    name: "edpBoldSearch",
})
export class EdpBoldSearchPipe implements PipeTransform {
    transform(text: string, search: string | null): string {
        const textFormatted = search ? text.replace(this.getRegexAccentsOptions(search), "<b>$1</b>") : text;
        return textFormatted;
    }

    getRegexAccentsOptions(search: string): RegExp {
        if (!search) {
            return new RegExp("", "gi");
        }
        const array = search?.split("").map(character =>
            character.toLowerCase()
                .replace("a", `["a"|"á"|"à"|"ã"|"â"]`)
                .replace("e", `["e"|"é"|"è"|"ê"]`)
                .replace("i", `["i"|"í"|"ì"|"î"]`)
                .replace("o", `["o"|"õ"|"ó"|"ò"|"ô"]`)
                .replace("u", `["u"|"ú"|"ù"|"û"]`)
        );
        if (array) {
            return new RegExp(`^(${array.join("")})`, "gi");
        }
    }
}
